import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

// Administrador: custom claim admin: true en el token de Firebase Auth (scripts/asignar-admin.js).
// El claim nuevo llega al renovarse el token: al volver a iniciar sesión o, solo, en menos de 1 hora.
export function useIsAdmin() {
  const { currentUser } = useAuth();
  const [state, setState] = useState({ loading: true, isAdmin: false });

  useEffect(() => {
    if (!currentUser) {
      setState({ loading: false, isAdmin: false });
      return undefined;
    }
    let alive = true;
    currentUser
      .getIdTokenResult()
      .then((result) => alive && setState({ loading: false, isAdmin: result.claims.admin === true }))
      .catch(() => alive && setState({ loading: false, isAdmin: false }));
    return () => {
      alive = false;
    };
  }, [currentUser]);

  return state;
}
